import { useWorkersService } from '@restworld/data-services';
import { useAuth } from '@restworld/feature-authentication';
import { useSetAtom } from 'jotai';
import { useCallback, useState } from 'react';
import { setWorkerCvAtom } from '../../global-state.worker-data';
// import { useUploadCV } from './use-upload-cv';

export function useDeleteCv({ onClose }: { onClose: () => void }) {
  const [isLoading, setIsLoading] = useState(false);
  const workerService = useWorkersService();
  const authContext = useAuth();
  const setWorkerCv = useSetAtom(setWorkerCvAtom);
  // const { setCVUploaded } = useUploadCV();
  async function closeTimeout() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(undefined);
      }, 1000);
    });
  }
  const handleDelete = useCallback(async () => {
    setIsLoading(true);
    try {
      await workerService.deleteCV(authContext?.user?.id);
      await closeTimeout();
      setWorkerCv(undefined);
      // setCVUploaded(false);
      onClose();
    } catch (err: any) {
      setIsLoading(false);
    }
  }, [authContext?.user?.id, onClose, setWorkerCv, workerService]);
  return { handleDelete, isLoading };
}
